<template>
  <div id="loader" class="vx-row">
    <div class="vx-col w-full md:w-1/2 mb-base">
      <br></br>
      <div class="vx-row">

        <div class="vx-col w-full w-1/2 md:w-1/2 xl:w-1/2">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="ActivityIcon"
            :statistic="campaign.settings.status.toUpperCase()"
            statisticTitle="Status"
          />
        </div>
        <div class="vx-col w-full w-1/2 md:w-1/2 xl:w-1/2">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="DollarSignIcon"
            :statistic="
              campaign.settings.smsCredit
            "
            statisticTitle="SMS CREDIT"
          />
           <!-- campaign.settings.currency + ' ' + campaign.settings.smsCredit -->
        </div>

        <div class="vx-col w-full w-1/2 md:w-1/2 xl:w-1/2">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="UserIcon"
            :statistic="campaign.settings.balance"
            statisticTitle="CREDIT BALANCE"
          />
        </div>
        <div class="vx-col w-full w-1/2 md:w-1/2 xl:w-1/2">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="CalendarIcon"
            :statistic="campaign.settings.expiry"
            statisticTitle="Expiry"
          />
        </div>
      </div>
    </div>

    <div class="vx-col   md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
      <vx-card title="Campaigns">
        <!-- CARD ACTION -->

        <div slot="no-body" v-if="campaign">
          <div class="vx-row text-center">
            <!-- Open Tickets Heading -->
            <div
              class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last"
            >
              <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                <h1 class="font-bold text-5xl">
                  {{ campaign['totalCampaign'] }}
                </h1>
                <small>Total Campaign</small>
              </div>
            </div>

            <!-- Chart -->
            <div
              class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6"
            >
              <vue-apex-charts
                type="radialBar"
                height="385"
                :options="chartOptions"
                :series="campaign.series"
              />
            </div>
          </div>

          <!-- Support Tracker Meta Data -->
          <div class="flex flex-row justify-between px-8 pb-4 mt-4">
            <p
              class="text-center"
              v-for="(val, key) in campaign.meta"
              :key="key"
            >
              <span class="block">{{ key }}</span>
              <span class="text-2xl font-semibold">{{ val }}</span>
            </p>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { axiosMixin } from '@/mixin/axiosMixin'
import { helperMixin } from '@/mixin/helperMixin'

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
export default {
  mixins: [axiosMixin, helperMixin],

  components: {
    VueApexCharts,
    StatisticsCardLine
  },
  data () {
    return {
      campaign: {},
      chartOptions: {
        plotOptions: {
          radialBar: {
            size: 158,
            offsetY: -30,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '65%'
            },
            track: {
              background: 'rgba(0,0,0,0)',
              strokeWidth: '100%'
            },
            dataLabels: {
              value: {
                offsetY: 30,
                color: '#99a2ac',
                fontSize: '2rem'
              }
            }
          }
        },
        colors: ['#EA5455'],
        fill: {
          type: 'gradient',
          gradient: {
            // enabled: true,
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#7367F0'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          dashArray: 8
        },
        chart: {
          sparkline: {}
        },
        labels: ['Completed Campaign']
      }
    }
  },

  created () {
    this.getDashboardData()
  },

  methods: {
    startLoading () {
      this.$vs.loading({
        container: '#loader',
        scale: 0.6
      })
    },
    closeLoading () {
      this.$vs.loading.close('#loader > .con-vs-loading')
    },
    getDashboardData () {
      this.aronPost('getDashboardData', '', '', '')
        .then(response => {
          if (response.status == 200) {
            this.campaign = response.data
            console.log('this.campaign:', this.campaign)
          }

          this.closeLoading()
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading()
        })
    }
  }
}
</script>

<style></style>
